module.exports = __webpack_public_path__ + "img/avatar-3.fcdb84a1.png";